const CookieType = {
  STRICTLY_NECESSARY: 1,
  PERFORMANCE: 2,
  FUNCTIONAL: 3,
  TARGETING: 4,
  SOCIAL_MEDIA: 5
};

const isCookieTypeAllowed = (type) => {
  const activeGroups = (typeof window !== 'undefined' && window.OnetrustActiveGroups) || '';
  return activeGroups.split(',').map((g) => g.trim()).includes(String(type));
};

const isFunctionalCookieAllowed = () => isCookieTypeAllowed(CookieType.FUNCTIONAL);
const isPerformanceCookieAllowed = () => isCookieTypeAllowed(CookieType.PERFORMANCE);

export {
  CookieType, isCookieTypeAllowed, isFunctionalCookieAllowed, isPerformanceCookieAllowed
};
